module.exports = __webpack_public_path__ + "static/media/desktop_vehiclerecall_banner.e236c75a.png";